import { FC } from "react";
import { HashRouter } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./components/services/AppRoutes";
import Layout from "./components/layout/Layout";
import { AppProvider } from "./context/AppContext";

const App: FC = () => {
  return (
    <HashRouter>
      <AppProvider>
        <Layout>
          <AppRoutes />
        </Layout>
      </AppProvider>
    </HashRouter>
  );
};

export default App;
